import { useBoosts } from '@/features/points/logic/seasonMew/useBoosts'
import { Badge } from '@/ui/atoms/badge/Badge'
import { Panel } from '@/ui/atoms/panel/Panel'
import { Typography } from '@/ui/atoms/typography/Typography'
import { Info } from '@/ui/molecules/info/Info'
import { cn } from '@/ui/utils/style'
import { Hourglass } from 'lucide-react'

export function Boosts() {
  const { data: boosts } = useBoosts()

  const hotStreakBoostActive = !!boosts?.hotStreakBoost.active

  return (
    <Panel.Wrapper className="flex flex-1 flex-col gap-2 p-9">
      <div>
        <Typography variant="h2" className="text-xl" gradient>
          Boosts
        </Typography>
      </div>

      <div className="flex h-16 items-center gap-2">
        <Typography variant="p" className="text-muted-foreground">
          Earn boosted points with hot streak boost
        </Typography>
      </div>

      <div>
        <RowItem
          label="Hot streak boost"
          description="1% Boost for each consecutive week earning points, maximum 10%!"
          value={hotStreakBoostActive ? `+${boosts?.hotStreakBoost.value}%` : 'up to 10%'}
          active={hotStreakBoostActive}
          Icon={Hourglass}
        />
      </div>
    </Panel.Wrapper>
  )
}

export function RowItem({
  Icon,
  description,
  label,
  value,
  withBorder,
  active,
}: {
  Icon: React.ElementType
  description: string
  label: string
  value: string
  withBorder?: boolean
  active?: boolean
}) {
  return (
    <div
      className={cn('flex items-center justify-between gap-2 py-3', {
        'border-white/4 border-t': withBorder,
        'opacity-20': !active,
      })}
    >
      <div className="flex items-center gap-2">
        <Icon className={cn('h-5 w-5 text-foreground', { 'text-primary': active })} />
        <Typography variant="p" className="text-sm">
          {label}
        </Typography>
        <Info>{description}</Info>
      </div>

      <div className="flex items-center gap-2">
        {active && (
          <Badge>
            <Typography variant="prompt" className="text-xs">
              Achieved
            </Typography>
          </Badge>
        )}
        <Typography variant="p" gradient className="font-bold text-sm">
          {value}
        </Typography>
      </div>
    </div>
  )
}
